import type { TierEnum } from '@/services/enums/TierEnum'
import type Affiliate from '@/services/models/Affiliate'
import type AggregatorClient from '@/services/models/AggregatorClient'
import type AggregatorQuoteReference from '@/services/models/AggregatorQuoteReference'
import type { Dictionary } from '@/types'
import { defineStore } from 'pinia'

interface State {
  aggregatorQuoteReference: AggregatorQuoteReference | null

  clickThroughSchemeTier: TierEnum | null

  client: AggregatorClient | null

  affiliate: Affiliate | null

  queryString: Dictionary<string | (string | null)[]>
}

const useAggregatorStore = defineStore('aggregator', {
  state: (): State => ({
    aggregatorQuoteReference: null,
    clickThroughSchemeTier: null,
    client: null,
    affiliate: null,
    queryString: {},
  }),
  actions: {
    setAggregatorQuoteReference(aggregatorQuoteReference: AggregatorQuoteReference): void {
      this.aggregatorQuoteReference = aggregatorQuoteReference
    },
    setAggregatorQuoteReferenceQuoteReference(quoteRef: string): void {
      if (this.aggregatorQuoteReference)
        this.aggregatorQuoteReference.quoteReference = quoteRef
    },
    setClickThroughSchemeTier(tier: TierEnum | null): void {
      this.clickThroughSchemeTier = tier
    },
    setAggregatorClient(client: AggregatorClient): void {
      this.client = client
    },
    setAffiliate(affiliate: Affiliate): void {
      this.affiliate = affiliate
    },
    clearAggregatorQuoteReference(): void {
      this.aggregatorQuoteReference = null
      this.clickThroughSchemeTier = null
    },
    clearAggregatorClient(): void {
      this.client = null
      this.affiliate = null
      this.queryString = {}
    },
    setQueryString(queryString: Dictionary<string | (string | null)[]>): void {
      this.queryString = queryString
    },
  },
})

export default useAggregatorStore
